/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ApplicationAnswersResponseAnswers } from './applicationAnswersResponseAnswers';

/**
 * Persisted answers + whether the primary JC still has fillable gaps.
 */
export interface ApplicationAnswersResponse {
  job_candidate_id: string;
  answers?: ApplicationAnswersResponseAnswers;
  applied_to_job_candidate_ids?: string[];
  application_questions_incomplete?: boolean;
  application_questions_soft_hint?: boolean;
}
